// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__bUIkI","short_line":"Footer_short_line__+-A8B","light":"Footer_light__gbq3C","dark":"Footer_dark__9GcIC"};